// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreShippingOptions = (client) => ({
    /**
     * `GET /store/shipping-options/return`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId GetReturnShippingOptions
     * @source packages/modules/b2c-core/src/api/store/shipping-options/return/route.ts
     */
    retrieveReturn: (query, headers) => client.fetch("/store/shipping-options/return", { method: "GET", query, headers }),
});
//# sourceMappingURL=shipping-options.js.map